import { getFirestore, doc } from 'firebase/firestore'

export const numberToEuro = function (num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const COMP = {
  name: 'TestPage',
  data() {
    return {
      message: 'Hello World',
    }
  },
  template: '<h3>{{message}}</h3>',
}

// #region String Utility
export const timestampToDate = function (timestamp) {
  if (timestamp) {
    const date = new Date(timestamp.seconds * 1000)
    const day = date.getUTCDate()
    let month = date.getUTCMonth() + 1
    month = month >= 10 ? month : '0' + month
    const year = date.getUTCFullYear()
    return `${day}.${month}.${year}`
  } else {
    return ''
  }
}
export const pluralToSingular = function (plural) {
  return plural.slice(0, -1)
}

export const capitalizeToLowercase = function (string) {
  return string.toLowerCase()
}
// #endregion

export const byString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1')
  s = s.replace(/^\./, '')
  var a = s.split('.')
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i]
    if (k in o) {
      o = o[k]
    } else {
      return
    }
  }
  return o
}

export const csvToJson = function (csv) {
  var lines = csv.split('\r\n')
  var result = []
  var headers = lines[0].split(',')

  for (var i = 1; i < lines.length; i++) {
    var obj = {}
    var currentline = lines[i].split(',')
    this.options.elements.forEach((element) => {
      let indexOf = headers.indexOf(element.key)
      if (indexOf != -1) {
        switch (element.type) {
          case 'bool':
            obj[element.key] = currentline[indexOf] === 'TRUE'
            break
          case 'number':
            obj[element.key] = parseInt(currentline[indexOf])
            break
          case 'select':
            obj[element.key] = doc(getFirestore(), currentline[indexOf])
            break
          default:
            obj[element.key] = currentline[indexOf]
            break
        }
      } else {
        obj[element.key] = element.default
      }
    })
    result.push(obj)
  }
  return result
}

export const toPRINT = function (documents) {
  //TODO implement
  let ejs = require('ejs')
  // let template = options.actions.export.ejs
  let WinPrint = window.open('', '', '')
  console.log('TEMPLATE', documents[0])
  let html = ejs.render(template, { document: documents[0] })
  WinPrint.document.write(html)
  WinPrint.document.close()
  WinPrint.focus()
  setTimeout(() => {
    WinPrint.print()
  }, 500)
  // WinPrint.close()
}

const template = `
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet"
integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"
integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p"
crossorigin="anonymous"></script>
<style>
@media print {
    @page {
        margin: 0;
    }
    body {
        margin: 1.6cm;
    }
}
</style>
<svg xmlns="http://www.w3.org/2000/svg" width="85.322" height="20.539" viewBox="0 0 85.322 20.539">
  <g id="Group_388" data-name="Group 388" transform="translate(-68.863 -37.097)">
      <g id="Group_142" data-name="Group 142" transform="translate(68.863 37.097)">
          <path id="Path_42" data-name="Path 42"
              d="M319.711,253.346a4.91,4.91,0,0,1,.5.189.674.674,0,0,1,.405.657c-.009.841,0,1.682,0,2.524v16.119c0,.9-.721,1.307-1.575.881a1.3,1.3,0,0,1-.42-.328q-4.522-5.55-9.033-11.108-1.875-2.307-3.752-4.612c-.038-.047-.082-.091-.164-.181v.333q0,7.56,0,15.119a.8.8,0,0,1-.706.872,1.139,1.139,0,0,1-1.224-.439.992.992,0,0,1-.072-.439q-.005-5.881,0-11.762c0-2.3.007-4.6-.007-6.9a.774.774,0,0,1,.514-.764,1.2,1.2,0,0,1,1.443.273q3.07,3.835,6.137,7.67l6.73,8.409c.024.031.052.06.126.144V254.342c0-.592.193-.819.81-.954a.416.416,0,0,0,.087-.041Z"
              transform="translate(-258.122 -253.346)" fill="#233043"></path>
          <path id="Path_43" data-name="Path 43"
              d="M96.061,253.346c.4.066.8.122,1.2.2a6.037,6.037,0,0,1,5.066,5.266,6.374,6.374,0,0,1-3.72,6.489c-.074.036-.147.074-.245.123.364.445.721.881,1.08,1.317q2.295,2.794,4.591,5.586a1.16,1.16,0,0,1,.289.743.749.749,0,0,1-.638.775,1.2,1.2,0,0,1-1.212-.382q-2.945-3.608-5.9-7.213a.568.568,0,0,0-.5-.236c-1.862.009-3.724.005-5.585.005h-.339v6.862a.992.992,0,0,1-1.361.951,1.107,1.107,0,0,1-.7-.532V253.87a1.021,1.021,0,0,1,.551-.524Zm-5.894,10.862h.313c1.8,0,3.591-.019,5.386.011a3.376,3.376,0,0,0,1.642-.4,4.667,4.667,0,0,0,2.715-4.95,4.1,4.1,0,0,0-1.648-2.687,4.825,4.825,0,0,0-2.845-.827c-1.819-.027-3.639-.016-5.458-.02a.546.546,0,0,0-.1.023Z"
              transform="translate(-88.093 -253.346)" fill="#233043"></path>
          <path id="Path_44" data-name="Path 44"
              d="M237.1,253.346a1,1,0,0,1,.556.571q3.1,6.681,6.223,13.355,1.291,2.768,2.58,5.538a1.087,1.087,0,0,1,.1.363.614.614,0,0,1-.343.639.622.622,0,0,1-.715-.12c-.773-.654-1.552-1.3-2.305-1.974a48.611,48.611,0,0,1-4.155-4.086c-.294-.334-.559-.691-.844-1.033a4.858,4.858,0,0,1-.986-2.581c-.214-1.635-.414-3.272-.556-4.914s-.2-3.307-.308-4.96a.75.75,0,0,1,.4-.8Z"
              transform="translate(-205.024 -253.346)" fill="#233043"></path>
          <path id="Path_45" data-name="Path 45"
              d="M192.073,253.346a.793.793,0,0,1,.393.827c-.124,1.9-.214,3.8-.361,5.695a32.715,32.715,0,0,1-.727,5.2,5.314,5.314,0,0,1-1.219,2.1,39.9,39.9,0,0,1-4.058,4.1c-.889.8-1.806,1.576-2.718,2.354-.331.283-.631.314-.877.135a.726.726,0,0,1-.173-.911q1.3-2.79,2.6-5.579,2.216-4.755,4.431-9.51c.593-1.274,1.191-2.546,1.777-3.823a1.157,1.157,0,0,1,.529-.594Z"
              transform="translate(-162.356 -253.346)" fill="#233043"></path>
          <path id="Path_46" data-name="Path 46" d="M88.644,253.346a1.021,1.021,0,0,0-.551.524v-.524Z"
              transform="translate(-88.093 -253.346)" fill="#233043"></path>
          <path id="Path_47" data-name="Path 47"
              d="M410.961,263.766q0-4.677,0-9.354c0-.582.289-.857.9-.857,2.029,0,4.059-.037,6.086.013a9.913,9.913,0,0,1,9.782,7.512,10.444,10.444,0,0,1-.842,7.55,9.629,9.629,0,0,1-6.906,5.09,13.522,13.522,0,0,1-2.481.244c-1.894.035-3.79.011-5.685.011a.754.754,0,0,1-.852-.807Q410.96,268.467,410.961,263.766Zm2.053,8.331h.31c1.32,0,2.64.017,3.959-.007a15.006,15.006,0,0,0,2.166-.158,7.111,7.111,0,0,0,6.038-4.977,10.4,10.4,0,0,0,.289-5.2,7.509,7.509,0,0,0-1.7-3.679,7.823,7.823,0,0,0-5.889-2.612c-1.667-.064-3.338-.017-5.008-.017a1.1,1.1,0,0,0-.162.023Z"
              transform="translate(-342.753 -253.502)" fill="#233043"></path>
      </g>
  </g>
</svg>
<h1>Configuration Request</h1>
<div>
  <h3>Details</h3>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        Date
      </div>
      <div class="col-6">
        <%= document._onCreateDate.toDate().toLocaleDateString(); %>
      </div>
      <div class="col-6">
        Product
      </div>
      <div class="col-6">
        <%= document.configuration.product.name %>
      </div>
    </div>
  </div>
  </div>
</div>
<div>
  <h3>Contact</h3>
  <div> <%= document.firstname + " " + document.lastname %> </div>
  <a href="mailto:<%= document.email %>"> <%= document.email %> </a>
  <br/>
  <a href="tel:<%= document.phone %>"> <%= document.phone %> </a>
  <div class="d-flex">
    <div class="me-2"> <%= document.country %> </div>
    <div class="me-2"> <%= document.zipCode %> </div>
    <div> <%= document.city %> </div>
    <div> <%= document.contact_method %> </div>
  </div>
</div>
<table class="table">
    <thead>
        <tr>
            <th scope="col">Name</th>
            <th scope="col">Price</th>
        </tr>
    </thead>
    <tbody>
        <% for(var i=0; i<document.configuration.options.length; i++) {%>
            <tr>
                <td>
                    <%= document.configuration.options[i]?.name %>
                </td>
                <td>
                    <%= document.configuration.options[i]?.price %>
                </td>
            </tr>
            <% } %>
    </tbody>
</table>
`

export const translateDataType = function (dataType) {
  if (typeof dataType == 'boolean') {
    return dataType ? 'Yes' : 'No'
  }
  return dataType
}

export const NAV_STATE = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  ICONS: 'ICONS',
}

export const EXPORT_TYPE = {
  JSON: 'JSON',
  CSV: 'CSV',
  PRINT: 'PRINT',
  TEMPLATE: 'TEMPLATE',
}

export const STATS_TYPE = {
  TODAY: 'TODAY',
  TOTAL: 'TOTAL',
}

export const CHART_TYPE = {
  DISTRIBUTION: 'DISTRIBUTION',
  WEEKLY_DISTRIBUTION: 'WEEKLY_DISTRIBUTION',
  CUSTOM: 'CUSTOM',
}

export const WEAK_DAYS = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
}

export const IMPORT_TYPE = {
  JSON: 'application/json',
  CSV: 'application/vnd.ms-excel',
}

export const isToday = function (someDate) {
  const today = new Date()
  return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear()
}

export const codeToCountry = function (code) {
  let country = ''
  for (let i = 0; i < countries.length; i++) {
    if (countries[i].value == code) {
      country = countries[i].text
      break
    }
  }
  return country
}

export const countries = [
  { value: null, text: 'All' },
  { value: 'AF', text: 'Afghanistan' },
  { value: 'AL', text: 'Albania' },
  { value: 'DZ', text: 'Algeria' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AD', text: 'Andorra' },
  { value: 'AO', text: 'Angola' },
  { value: 'AI', text: 'Anguilla' },
  { value: 'AG', text: 'Antigua and Barbuda' },
  { value: 'AR', text: 'Argentina' },
  { value: 'AM', text: 'Armenia' },
  { value: 'AW', text: 'Aruba' },
  { value: 'AU', text: 'Australia' },
  { value: 'AT', text: 'Austria' },
  { value: 'AZ', text: 'Azerbaijan' },
  { value: 'BS', text: 'Bahamas' },
  { value: 'BH', text: 'Bahrain' },
  { value: 'BD', text: 'Bangladesh' },
  { value: 'BB', text: 'Barbados' },
  { value: 'BY', text: 'Belarus' },
  { value: 'BE', text: 'Belgium' },
  { value: 'BZ', text: 'Belize' },
  { value: 'BJ', text: 'Benin' },
  { value: 'BM', text: 'Bermuda' },
  { value: 'BT', text: 'Bhutan' },
  { value: 'BO', text: 'Bolivia' },
  { value: 'BQ', text: 'Bonaire' },
  { value: 'BA', text: 'Bosnia-Herzegovina' },
  { value: 'BW', text: 'Botswana' },
  { value: 'BV', text: 'Bouvet Island' },
  { value: 'BR', text: 'Brazil' },
  { value: 'IO', text: 'British Indian Ocean Territory' },
  { value: 'BN', text: 'Brunei Darussalam' },
  { value: 'BG', text: 'Bulgaria' },
  { value: 'BF', text: 'Burkina Faso' },
  { value: 'BI', text: 'Burundi' },
  { value: 'CV', text: 'Cabo Verde' },
  { value: 'KH', text: 'Cambodia' },
  { value: 'CM', text: 'Cameroon' },
  { value: 'CA', text: 'Canada' },
  { value: 'KY', text: 'Cayman Islands' },
  { value: 'CF', text: 'Central African Republic' },
  { value: 'TD', text: 'Chad' },
  { value: 'CL', text: 'Chile' },
  { value: 'CN', text: 'China' },
  { value: 'CX', text: 'Christmas Island' },
  { value: 'CC', text: 'Cocos (Keeling) Islands' },
  { value: 'CO', text: 'Colombia' },
  { value: 'KM', text: 'Comoros' },
  { value: 'CD', text: 'Congo' },
  { value: 'CG', text: 'Congo' },
  { value: 'CK', text: 'Cook Islands' },
  { value: 'CR', text: 'Costa Rica' },
  { value: 'HR', text: 'Croatia' },
  { value: 'CU', text: 'Cuba' },
  { value: 'CW', text: 'Curaçao' },
  { value: 'CY', text: 'Cyprus' },
  { value: 'CZ', text: 'Czechia' },
  { value: 'CI', text: "Côte d'Ivoire" },
  { value: 'DK', text: 'Denmark' },
  { value: 'DJ', text: 'Djibouti' },
  { value: 'DM', text: 'Dominica' },
  { value: 'DO', text: 'Dominican Republic' },
  { value: 'EC', text: 'Ecuador' },
  { value: 'EG', text: 'Egypt' },
  { value: 'SV', text: 'El Salvador' },
  { value: 'GQ', text: 'Equatorial Guinea' },
  { value: 'ER', text: 'Eritrea' },
  { value: 'EE', text: 'Estonia' },
  { value: 'SZ', text: 'Eswatini' },
  { value: 'ET', text: 'Ethiopia' },
  { value: 'FK', text: 'Falkland Islands' },
  { value: 'FO', text: 'Faroe Islands' },
  { value: 'FJ', text: 'Fiji' },
  { value: 'FI', text: 'Finland' },
  { value: 'FR', text: 'France' },
  { value: 'GF', text: 'French Guiana' },
  { value: 'PF', text: 'French Polynesia' },
  { value: 'TF', text: 'French Southern Territories' },
  { value: 'GA', text: 'Gabon' },
  { value: 'GM', text: 'Gambia' },
  { value: 'GE', text: 'Georgia' },
  { value: 'DE', text: 'Germany' },
  { value: 'GH', text: 'Ghana' },
  { value: 'GI', text: 'Gibraltar' },
  { value: 'GR', text: 'Greece' },
  { value: 'GL', text: 'Greenland' },
  { value: 'GD', text: 'Grenada' },
  { value: 'GP', text: 'Guadeloupe' },
  { value: 'GU', text: 'Guam' },
  { value: 'GT', text: 'Guatemala' },
  { value: 'GG', text: 'Guernsey' },
  { value: 'GN', text: 'Guinea' },
  { value: 'GW', text: 'Guinea-Bissau' },
  { value: 'GY', text: 'Guyana' },
  { value: 'HT', text: 'Haiti' },
  { value: 'VA', text: 'Holy See' },
  { value: 'HN', text: 'Honduras' },
  { value: 'HK', text: 'Hong Kong' },
  { value: 'HU', text: 'Hungary' },
  { value: 'IS', text: 'Iceland' },
  { value: 'IN', text: 'India' },
  { value: 'ID', text: 'Indonesia' },
  { value: 'IR', text: 'Iran' },
  { value: 'IQ', text: 'Iraq' },
  { value: 'IE', text: 'Ireland' },
  { value: 'IM', text: 'Isle of Man' },
  { value: 'IL', text: 'Israel' },
  { value: 'IT', text: 'Italy' },
  { value: 'JM', text: 'Jamaica' },
  { value: 'JP', text: 'Japan' },
  { value: 'JE', text: 'Jersey' },
  { value: 'JO', text: 'Jordan' },
  { value: 'KZ', text: 'Kazakhstan' },
  { value: 'KE', text: 'Kenya' },
  { value: 'KI', text: 'Kiribati' },
  { value: 'KR', text: 'Korea' },
  { value: 'KW', text: 'Kuwait' },
  { value: 'KG', text: 'Kyrgyzstan' },
  { value: 'LA', text: "Lao People's Democratic Republic" },
  { value: 'LV', text: 'Latvia' },
  { value: 'LB', text: 'Lebanon' },
  { value: 'LS', text: 'Lesotho' },
  { value: 'LR', text: 'Liberia' },
  { value: 'LY', text: 'Libya' },
  { value: 'LI', text: 'Liechtenstein' },
  { value: 'LT', text: 'Lithuania' },
  { value: 'LU', text: 'Luxembourg' },
  { value: 'MO', text: 'Macao' },
  { value: 'MG', text: 'Madagascar' },
  { value: 'MW', text: 'Malawi' },
  { value: 'MY', text: 'Malaysia' },
  { value: 'MV', text: 'Maldives' },
  { value: 'ML', text: 'Mali' },
  { value: 'MT', text: 'Malta' },
  { value: 'MH', text: 'Marshall Islands' },
  { value: 'MQ', text: 'Martinique' },
  { value: 'MR', text: 'Mauritania' },
  { value: 'MU', text: 'Mauritius' },
  { value: 'YT', text: 'Mayotte' },
  { value: 'MX', text: 'Mexico' },
  { value: 'FM', text: 'Micronesia (Federated States of)' },
  { value: 'MD', text: 'Moldova (the Republic of)' },
  { value: 'MC', text: 'Monaco' },
  { value: 'MN', text: 'Mongolia' },
  { value: 'ME', text: 'Montenegro' },
  { value: 'MS', text: 'Montserrat' },
  { value: 'MA', text: 'Morocco' },
  { value: 'MZ', text: 'Mozambique' },
  { value: 'MM', text: 'Myanmar' },
  { value: 'NA', text: 'Namibia' },
  { value: 'NR', text: 'Nauru' },
  { value: 'NP', text: 'Nepal' },
  { value: 'NL', text: 'Netherlands' },
  { value: 'NC', text: 'New Caledonia' },
  { value: 'NZ', text: 'New Zealand' },
  { value: 'NI', text: 'Nicaragua' },
  { value: 'NE', text: 'Niger' },
  { value: 'NG', text: 'Nigeria' },
  { value: 'NU', text: 'Niue' },
  { value: 'NF', text: 'Norfolk Island' },
  { value: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NO', text: 'Norway' },
  { value: 'OM', text: 'Oman' },
  { value: 'PK', text: 'Pakistan' },
  { value: 'PW', text: 'Palau' },
  { value: 'PS', text: 'Palestine, State of' },
  { value: 'PA', text: 'Panama' },
  { value: 'PG', text: 'Papua New Guinea' },
  { value: 'PY', text: 'Paraguay' },
  { value: 'PE', text: 'Peru' },
  { value: 'PH', text: 'Philippines' },
  { value: 'PN', text: 'Pitcairn' },
  { value: 'PL', text: 'Poland' },
  { value: 'PT', text: 'Portugal' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'QA', text: 'Qatar' },
  { value: 'MK', text: 'Republic of North Macedonia' },
  { value: 'RO', text: 'Romania' },
  { value: 'RU', text: 'Russian Federation' },
  { value: 'RW', text: 'Rwanda' },
  { value: 'RE', text: 'Réunion' },
  { value: 'BL', text: 'Saint Barthélemy' },
  { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', text: 'Saint Kitts and Nevis' },
  { value: 'LC', text: 'Saint Lucia' },
  { value: 'MF', text: 'Saint Martin (French part)' },
  { value: 'PM', text: 'Saint Pierre and Miquelon' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'Samoa' },
  { value: 'SM', text: 'San Marino' },
  { value: 'ST', text: 'Sao Tome and Principe' },
  { value: 'SA', text: 'Saudi Arabia' },
  { value: 'SN', text: 'Senegal' },
  { value: 'RS', text: 'Serbia' },
  { value: 'SC', text: 'Seychelles' },
  { value: 'SL', text: 'Sierra Leone' },
  { value: 'SG', text: 'Singapore' },
  { value: 'SX', text: 'Sint Maarten (Dutch part)' },
  { value: 'SK', text: 'Slovakia' },
  { value: 'SI', text: 'Slovenia' },
  { value: 'SB', text: 'Solomon Islands' },
  { value: 'SO', text: 'Somalia' },
  { value: 'ZA', text: 'South Africa' },
  { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', text: 'South Sudan' },
  { value: 'ES', text: 'Spain' },
  { value: 'LK', text: 'Sri Lanka' },
  { value: 'SD', text: 'Sudan' },
  { value: 'SR', text: 'Suriname' },
  { value: 'SJ', text: 'Svalbard and Jan Mayen' },
  { value: 'SE', text: 'Sweden' },
  { value: 'CH', text: 'Switzerland' },
  { value: 'SY', text: 'Syrian Arab Republic' },
  { value: 'TW', text: 'Taiwan' },
  { value: 'TJ', text: 'Tajikistan' },
  { value: 'TZ', text: 'Tanzania, United Republic of' },
  { value: 'TH', text: 'Thailand' },
  { value: 'TL', text: 'Timor-Leste' },
  { value: 'TG', text: 'Togo' },
  { value: 'TK', text: 'Tokelau' },
  { value: 'TO', text: 'Tonga' },
  { value: 'TT', text: 'Trinidad and Tobago' },
  { value: 'TN', text: 'Tunisia' },
  { value: 'TR', text: 'Turkey' },
  { value: 'TM', text: 'Turkmenistan' },
  { value: 'TC', text: 'Turks and Caicos Islands' },
  { value: 'TV', text: 'Tuvalu' },
  { value: 'UG', text: 'Uganda' },
  { value: 'UA', text: 'Ukraine' },
  { value: 'AE', text: 'United Arab Emirates' },
  { value: 'GB', text: 'United Kingdom' },
  { value: 'UM', text: 'United States Minor Outlying Islands' },
  { value: 'US', text: 'United States of America' },
  { value: 'UY', text: 'Uruguay' },
  { value: 'UZ', text: 'Uzbekistan' },
  { value: 'VU', text: 'Vanuatu' },
  { value: 'VE', text: 'Venezuela (Bolivarian Republic of)' },
  { value: 'VN', text: 'Vietnam' },
  { value: 'VG', text: 'Virgin Islands (British)' },
  { value: 'VI', text: 'Virgin Islands (U.S.)' },
  { value: 'WF', text: 'Wallis and Futuna' },
  { value: 'EH', text: 'Western Sahara' },
  { value: 'YE', text: 'Yemen' },
  { value: 'ZM', text: 'Zambia' },
  { value: 'ZW', text: 'Zimbabwe' },
  { value: 'AX', text: 'Åland Islands' },
]

export const truncateString = function (str, maxLenght) {
  if (str.length > maxLenght) {
    return str.substring(0, maxLenght) + '...'
  } else {
    return str
  }
}

// export const country = {
//   ISO: {

//   },
//   fromALPHA2: function(ALPHA2){
//     return ALPHA2[ALPHA2]
//   }
// }

export const COUNTRY_CODES = {
  AF: 'Afghanistan',
  AL: 'Albania',
  DZ: 'Algeria',
  AS: 'American Samoa',
  AD: 'Andorra',
  AO: 'Angola',
  AI: 'Anguilla',
  AG: 'Antigua and Barbuda',
  AR: 'Argentina',
  AM: 'Armenia',
  AW: 'Aruba',
  AU: 'Australia',
  AT: 'Austria',
  AZ: 'Azerbaijan',
  BS: 'Bahamas',
  BH: 'Bahrain',
  BD: 'Bangladesh',
  BB: 'Barbados',
  BY: 'Belarus',
  BE: 'Belgium',
  BZ: 'Belize',
  BJ: 'Benin',
  BM: 'Bermuda',
  BT: 'Bhutan',
  BO: 'Bolivia',
  BQ: 'Bonaire',
  BA: 'Bosnia-Herzegovina',
  BW: 'Botswana',
  BV: 'Bouvet Island',
  BR: 'Brazil',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  BG: 'Bulgaria',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  CV: 'Cabo Verde',
  KH: 'Cambodia',
  CM: 'Cameroon',
  CA: 'Canada',
  KY: 'Cayman Islands',
  CF: 'Central African Republic',
  TD: 'Chad',
  CL: 'Chile',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CO: 'Colombia',
  KM: 'Comoros',
  CD: 'Congo',
  CG: 'Congo',
  CK: 'Cook Islands',
  CR: 'Costa Rica',
  HR: 'Croatia',
  CU: 'Cuba',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  CI: "Côte d'Ivoire",
  DK: 'Denmark',
  DJ: 'Djibouti',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  EC: 'Ecuador',
  EG: 'Egypt',
  SV: 'El Salvador',
  GQ: 'Equatorial Guinea',
  ER: 'Eritrea',
  EE: 'Estonia',
  SZ: 'Eswatini',
  ET: 'Ethiopia',
  FK: 'Falkland Islands',
  FO: 'Faroe Islands',
  FJ: 'Fiji',
  FI: 'Finland',
  FR: 'France',
  GF: 'French Guiana',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GA: 'Gabon',
  GM: 'Gambia',
  GE: 'Georgia',
  DE: 'Germany',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GR: 'Greece',
  GL: 'Greenland',
  GD: 'Grenada',
  GP: 'Guadeloupe',
  GU: 'Guam',
  GT: 'Guatemala',
  GG: 'Guernsey',
  GN: 'Guinea',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HT: 'Haiti',
  VA: 'Holy See',
  HN: 'Honduras',
  HK: 'Hong Kong',
  HU: 'Hungary',
  IS: 'Iceland',
  IN: 'India',
  ID: 'Indonesia',
  IR: 'Iran',
  IQ: 'Iraq',
  IE: 'Ireland',
  IM: 'Isle of Man',
  IL: 'Israel',
  IT: 'Italy',
  JM: 'Jamaica',
  JP: 'Japan',
  JE: 'Jersey',
  JO: 'Jordan',
  KZ: 'Kazakhstan',
  KE: 'Kenya',
  KI: 'Kiribati',
  KR: 'Korea',
  KW: 'Kuwait',
  KG: 'Kyrgyzstan',
  LA: "Lao People's Democratic Republic",
  LV: 'Latvia',
  LB: 'Lebanon',
  LS: 'Lesotho',
  LR: 'Liberia',
  LY: 'Libya',
  LI: 'Liechtenstein',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  MO: 'Macao',
  MG: 'Madagascar',
  MW: 'Malawi',
  MY: 'Malaysia',
  MV: 'Maldives',
  ML: 'Mali',
  MT: 'Malta',
  MH: 'Marshall Islands',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MU: 'Mauritius',
  YT: 'Mayotte',
  MX: 'Mexico',
  FM: 'Micronesia (Federated States of)',
  MD: 'Moldova (the Republic of)',
  MC: 'Monaco',
  MN: 'Mongolia',
  ME: 'Montenegro',
  MS: 'Montserrat',
  MA: 'Morocco',
  MZ: 'Mozambique',
  MM: 'Myanmar',
  NA: 'Namibia',
  NR: 'Nauru',
  NP: 'Nepal',
  NL: 'Netherlands',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NI: 'Nicaragua',
  NE: 'Niger',
  NG: 'Nigeria',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  NO: 'Norway',
  OM: 'Oman',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestine, State of',
  PA: 'Panama',
  PG: 'Papua New Guinea',
  PY: 'Paraguay',
  PE: 'Peru',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PT: 'Portugal',
  PR: 'Puerto Rico',
  QA: 'Qatar',
  MK: 'Republic of North Macedonia',
  RO: 'Romania',
  RU: 'Russian Federation',
  RW: 'Rwanda',
  RE: 'Réunion',
  BL: 'Saint Barthélemy',
  SH: 'Saint Helena, Ascension and Tristan da Cunha',
  KN: 'Saint Kitts and Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin (French part)',
  PM: 'Saint Pierre and Miquelon',
  VC: 'Saint Vincent and the Grenadines',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome and Principe',
  SA: 'Saudi Arabia',
  SN: 'Senegal',
  RS: 'Serbia',
  SC: 'Seychelles',
  SL: 'Sierra Leone',
  SG: 'Singapore',
  SX: 'Sint Maarten (Dutch part)',
  SK: 'Slovakia',
  SI: 'Slovenia',
  SB: 'Solomon Islands',
  SO: 'Somalia',
  ZA: 'South Africa',
  GS: 'South Georgia and the South Sandwich Islands',
  SS: 'South Sudan',
  ES: 'Spain',
  LK: 'Sri Lanka',
  SD: 'Sudan',
  SR: 'Suriname',
  SJ: 'Svalbard and Jan Mayen',
  SE: 'Sweden',
  CH: 'Switzerland',
  SY: 'Syrian Arab Republic',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TZ: 'Tanzania, United Republic of',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad and Tobago',
  TN: 'Tunisia',
  TR: 'Turkey',
  TM: 'Turkmenistan',
  TC: 'Turks and Caicos Islands',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukraine',
  AE: 'United Arab Emirates',
  GB: 'United Kingdom',
  UM: 'United States Minor Outlying Islands',
  US: 'United States of America',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VE: 'Venezuela (Bolivarian Republic of)',
  VN: 'Vietnam',
  VG: 'Virgin Islands (British)',
  VI: 'Virgin Islands (U.S.)',
  WF: 'Wallis and Futuna',
  EH: 'Western Sahara',
  YE: 'Yemen',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AX: 'Åland Islands',
}

export const isDateInThisWeek = function (date) {
  const today = new Date()
  // get first date of week
  const firstDayOfWeek = new Date(today.setDate(today.getDate() - today.getDay()))
  // get last date of week
  const lastDayOfWeek = new Date(firstDayOfWeek)
  lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6)
  // if date is equal or within the first and last dates of the week
  return date >= firstDayOfWeek && date <= lastDayOfWeek
}

/**
 * Enum for chart type
 * @readonly
 * @enum {symbol}
 */
export const ChartType = Object.freeze({
  Bar: Symbol('Bar'),
  Pie: Symbol('Pie'),
  Line: Symbol('Line'),
})

/**
 * Enum for chart type
 * @param {Date} date
 */
export const dateToString = function (date) {
  let day, month, year

  day = date.getDate()
  month = date.getMonth() + 1
  year = date.getFullYear()

  day = day.toString().padStart(2, '0')

  month = month.toString().padStart(2, '0')

  return `${day}-${month}-${year}`
}

/**
 * Formats a number to currency
 * @param {number} n The number to format
 * @returns {string} The formatted number
 */
export const formatToCurrency = function (n) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
